import type { FC } from 'react';
import { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { PapiCorePackageV3 } from '@wix/da-papi-types';
import CoreRecurringPriceAndCycle from '../../../../CoreRecurringPriceAndCycle';
import { useTranslation } from 'react-i18next';

import s from './PackageLabel.scss';

interface Props {
  corePackage: PapiCorePackageV3;
  showDiscountedPrice: boolean;
}

const PackageLabel: FC<Props> = ({ corePackage, showDiscountedPrice }) => {
  const { interval: cycle } = corePackage;
  const { t } = useTranslation();

  const isMobile = useContext(MobileContext);

  const isDisabled = corePackage.status === 'disabled';

  const cycleLabel =
    cycle === 'year'
      ? t('packagePicker.billingCycle.new.yearly')
      : t('packagePicker.billingCycle.new.monthly');

  // Determine the price display mode based on discount availability
  const getPriceDisplayMode = () => {
    if (!showDiscountedPrice || !corePackage.monthlyPriceBeforeDiscount) {
      return 'original';
    }
    return 'both'; // Show original (strikethrough) + discounted
  };

  return isMobile ? (
    <div className={s['cycle']}>{cycleLabel}</div>
  ) : (
    <div className={c(s['root'], isDisabled && s['disabled'])}>
      <div className={s['cycle']}>{cycleLabel}</div>
      <CoreRecurringPriceAndCycle
        corePackage={corePackage}
        priceStyle="bold"
        priceDisplayMode={getPriceDisplayMode()}
      />
    </div>
  );
};
PackageLabel.displayName = 'PackageLabel';

export default PackageLabel;
